import { LinearProgress, Typography } from '@mui/material';

type EventParticipantsProgressBarProps = {
  current: number;
  total: number;
};

export const EventParticipantsProgressBar = (props: EventParticipantsProgressBarProps) => {
  const { current, total } = props;

  const progress = (current / total) * 100;

  return (
    <div style={{ position: 'relative', width: '90%' }}>
      <LinearProgress variant='determinate' value={progress} sx={{ height: '1.5rem', borderRadius: '5px' }} />
      <Typography
        variant='caption'
        align='center'
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          color: 'white',
        }}
      >
        {`${current}/${total}`}
      </Typography>
    </div>
  );
};
